<template>
  <div>
    <div class="row">
      <div :class="['col_12', { loading_overlay: loading }]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_6">
                <div :class="['form-group', { has_error: errorFor('name') }]">
                  <label>{{ $t('common.name') }}</label>
                  <input type="text" v-model="form.name" class="form_global" />
                  <v-errors :errors="errorFor('name')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('sort') }]">
                  <label>{{ $t('common.sort') }}</label>
                  <input
                    type="integer"
                    v-model="form.sort"
                    class="form_global"
                  />
                  <v-errors :errors="errorFor('sort')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('status') }]">
                  <label>{{ $t('common.status') }}</label>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="active"
                        value="1"
                        v-model="form.status"
                      />
                      <label for="active">{{ $t('common.active') }}</label>
                    </div>
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="inactive"
                        value="0"
                        v-model="form.status"
                      />
                      <label for="inactive">{{ $t('common.inactive') }}</label>
                    </div>
                  </div>
                  <v-errors :errors="errorFor('status')" />
                </div>
              </div>
              <div class="col_6">
                <div
                  :class="['form-group', { has_error: errorFor('color_code') }]"
                >
                  <label>{{ $t('common.color_code') }}</label>
                  <input
                    type="color"
                    v-model="form.color_code"
                    class="form_global"
                  />
                  <v-errors :errors="errorFor('color_code')" />
                </div>
              </div>
              <div class="col_6">
                <div class="form-group">
                  <label>{{ $t('common.photo') }}</label>
                  <input
                    type="file"
                    class="form_global"
                    ref="photo"
                    @input="onFileChange($event)"
                    accept="image/png, image/gif, image/jpeg, image/webp"
                  />
                  <v-errors :errors="errorFor('photo')"></v-errors>
                  <div class="video_list mt_10" v-if="tempPhoto || form.photo">
                    <div class="inner">
                      <div class="inner_wrap">
                        <img v-if="tempPhoto" :src="tempPhoto" alt="" />
                        <img v-else :src="form.photo" alt="" />
                        <div class="icons">
                          <span @click.prevent="removeTempPhoto()"
                            ><i class="lni lni-trash"></i
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d_flex_end form_action_btn">
              <router-link
                class="btn btn_danger ml_10"
                :to="{ name: cancelRouteName }"
                >{{ $t('common.cancel') }}</router-link
              >
              <button class="btn btn_blue ml_10" @click.prevent="submit">
                {{ $t('common.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      title: this.$t('sidebar.areas.add_area'),
      cancelRouteName: 'settings_area',
      form: {
        name: '',
        sort: '',
        color_code: '',
        photo: '',
        status: 1,
      },
      tempPhoto: '',
      value: null,
    };
  },
  mounted() {},
  created() {
    if (this.$route.name === 'settings_area_edit') {
      this.axios.get('/areas/' + this.$route.params.id).then((response) => {
        this.form = response.data.data;
      });
      this.title = this.$t('sidebar.areas.edit_area');
    }
  },
  methods: {
    onFileChange(e) {
      this.form.photo = e.target.files[0];
      this.tempPhoto = URL.createObjectURL(e.target.files[0]);
    },
    removeTempPhoto() {
      this.tempPhoto = '';
      this.form.photo = '';
      this.$refs.photo.value = null;
    },
    sanitize(inputHtml) {
      return inputHtml;
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      let formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      if (this.$route.name === 'settings_area_edit') {
        formData.append('_method', 'PATCH');

        this.axios
          .post('/areas/' + this.$route.params.id, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$router.push({
              name: 'settings_area',
            });
            this.showSuccessMsg(this.$t('common.updateSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios
          .post('/areas/', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$router.push({
              name: 'settings_area',
            });
            this.showSuccessMsg(this.$t('common.addSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
